var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        "header-bg-variant": "dark",
        "body-bg-variant": "light",
        "header-text-variant": "white",
        size: "lg",
        centered: "",
      },
    },
    [
      _c("span", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _c("span", { attrs: { id: "manuales-modal-title" } }, [
          _vm._v(_vm._s(_vm.$t("manuales.modal.title"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-list-group",
        { attrs: { flush: "" } },
        _vm._l(_vm.manuales, function (manual) {
          return _c(
            "b-list-group-item",
            {
              key: manual.id,
              staticClass:
                "d-flex justify-content-between align-items-center bg-transparent",
              attrs: {
                id: "manual-" + manual.id,
                href: manual.url,
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
            [
              _c(
                "span",
                [
                  _c("font-awesome-icon", {
                    staticClass: "text-danger mr-2",
                    attrs: { icon: "file-pdf" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { textContent: _vm._s(_vm.$t(manual.labelKey)) },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "icon-descargar" }),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer",
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-primary", block: "" },
              on: {
                click: function ($event) {
                  return _vm.closeModal()
                },
              },
            },
            [
              _c("span", { staticClass: "icon-cerrar mr-1" }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  textContent: _vm._s(_vm.$t("entity.action.close")),
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }